export default __webpack_public_path__ + "static/media/intstrument.d2495013.jpg";